import React from 'react';
import { RibbonType } from './types';

import useRibbonStyles from './useStyles';

export const DATA_TESTID = 'Ribbon';

export default function Ribbon({ children, packageName }: RibbonType): React.ReactElement {
  const { RibbonStyle } = useRibbonStyles({ packageName });
  return (
    <aside data-testid={DATA_TESTID} className={RibbonStyle}>
      <p>{children}</p>
    </aside>
  );
}
